import { Icon } from "@iconify/react";
import React from "react";

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <i className="cs_accent_bg">
          <Icon icon="ep:location" />
        </i>
        VILLA 170, SY NO 192P, Magnas Majestic Meadows, Kollur Ramachandrapuram, Tellapur, Sangareddy, Telangana - 502032
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="fluent:call-24-regular" />
        </i>
        +91 95155 23705
      </li>
      <li>
        <i className="cs_accent_bg">
          <Icon icon="bi:envelope" />
        </i>
        contact@v-doc.in
      </li>
    </ul>
  );
}
